export enum StepType {
  Bid = 'BID',
  Offer = 'OFFER',
}
